import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { AuthShell, Field } from "@/pages/Login";

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", company: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(form);
      toast.success("Account created — let's add your domain");
      navigate("/app/domains");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your account" subtitle="Start sending from your domain in minutes">
      <form onSubmit={submit} className="mt-8 space-y-4">
        <Field label="Full name" data-testid="signup-name" value={form.name} onChange={set("name")} placeholder="Jane Doe" required />
        <Field label="Company" data-testid="signup-company" value={form.company} onChange={set("company")} placeholder="Acme Inc" />
        <Field label="Work email" type="email" data-testid="signup-email" value={form.email} onChange={set("email")} placeholder="you@company.com" required />
        <Field label="Password" type="password" data-testid="signup-password" value={form.password} onChange={set("password")} placeholder="min 6 characters" required minLength={6} />
        <button data-testid="signup-submit" disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-500 py-2.5 font-semibold text-[#04120c] transition-colors hover:bg-emerald-400 disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Create account
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-slate-400">
        Already have an account? <Link to="/login" className="font-medium text-emerald-400 hover:underline">Sign in</Link>
      </p>
    </AuthShell>
  );
}
